import { Component } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw, Home } from "lucide-react";

/**
 * ErrorBoundary — Cattura errori di rendering nei pannelli figli ed evita
 * lo "schermo nero" quando una pagina React va in crash (es. API fallita, dato non previsto).
 * Mostra un messaggio dismissibile con pulsanti "Riprova" e "Torna alla home".
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log in console per diagnostica — niente throw
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (!this.state.hasError) return this.props.children;
    const message = this.state.error?.message || "Errore inatteso nel caricamento del pannello.";
    return (
      <div className="max-w-xl mx-auto my-12" data-testid="error-boundary">
        <div className="rounded-lg border border-destructive/40 bg-destructive/5 p-6 space-y-4 text-center">
          <div className="inline-flex items-center justify-center h-14 w-14 rounded-full bg-destructive/10 mx-auto">
            <AlertTriangle className="h-7 w-7 text-destructive" />
          </div>
          <h2 className="text-lg font-extrabold text-destructive">Errore di caricamento dati</h2>
          <p className="text-sm text-muted-foreground break-words">{String(message).slice(0, 400)}</p>
          <div className="flex gap-2 justify-center">
            <Button variant="outline" onClick={this.reset} data-testid="error-boundary-retry">
              <RefreshCw className="h-4 w-4 mr-2" /> Riprova
            </Button>
            <Button onClick={() => { window.location.href = "/"; }} data-testid="error-boundary-home">
              <Home className="h-4 w-4 mr-2" /> Torna alla home
            </Button>
          </div>
          <p className="text-[10px] text-muted-foreground">Se il problema persiste ricarica la pagina o esegui logout e login.</p>
        </div>
      </div>
    );
  }
}
